import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import config from './config/config';

function UnauthenticatedContent() {
  const { instance, inProgress, accounts } = useMsal();

  useEffect(() => {
    if (accounts.length === 0 && inProgress === InteractionStatus.None) {
      instance.loginRedirect({
        scopes: config.AzureAd.Scopes,
        prompt: 'select_account',
      }).catch(error => {
        console.error('Login failed:', error);
      });
    }
  }, [instance, inProgress, accounts]);

  return (
    <div>
      <h3>Redirecting to login...</h3>
    </div>
  );
}

export default UnauthenticatedContent;
